import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface AttentionSampleItem {
  id: number;
  address: string | null;
  insured: string | null;
}

export interface AttentionCategory {
  key: string;
  label: string;
  count: number;
  href: string;
  sample: AttentionSampleItem[];
}

export function useNeedsAttention() {
  return useQuery({
    queryKey: ["dashboard", "needs-attention"],
    queryFn: () => api.get<{ categories: AttentionCategory[] }>("/api/dashboard/needs-attention"),
  });
}

export interface RecentPdfItem {
  id: string;
  insuranceId: number;
  address: string | null;
  format: string;
  generatedAt: string;
  generatedBy: string;
}

export function useRecentPdfs(limit = 10) {
  return useQuery({
    queryKey: ["dashboard", "recent-pdfs", limit],
    queryFn: () => api.get<{ items: RecentPdfItem[] }>(`/api/dashboard/recent-pdfs?limit=${limit}`),
  });
}
